module.exports = __webpack_public_path__ + "static/media/Proven-record-illustration.10c56657.svg";